const SuccessGreyIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.75" y="0.75" width="22.5" height="22.5" rx="11.25" fill="#F7F7F7"/>
      <rect x="0.75" y="0.75" width="22.5" height="22.5" rx="11.25" stroke="#D9D9D9" stroke-width="1.5"/>
      <g clip-path="url(#clip0_7390_73845)">
        <path d="M6.99976 12.3333L10.3331 15.6667L16.9998 9" stroke="#D9D9D9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </g>
      <defs>
        <clipPath id="clip0_7390_73845">
          <rect width="16" height="16" fill="white" transform="translate(4 4)"/>
        </clipPath>
      </defs>
    </svg>
  );
};

export default SuccessGreyIcon;
